import React from 'react';
import { PREDEFINED_TENANTS } from 'swag-common/constants/main-swag.constants';
import { CustomInkFooter } from '../../../../../common/components/custom-ink-footer';
const isCustomInkFooter = window.swag.tenant === PREDEFINED_TENANTS.CUSTOM_INK;
export const getCustomInkFooter = () => isCustomInkFooter ? /*#__PURE__*/React.createElement(CustomInkFooter, null) : null;